var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend-item-container ma-2"},[_c('div',{staticClass:"legend-bar mr-2",style:({'background-color': _vm.barColor})}),_c('div',{staticClass:"legend-label ma-auto font-size-00",domProps:{"innerHTML":_vm._s(_vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }